export const advanceConstants = {
  DEVICE_TYPE__SET: 'DEVICE_TYPE__SET',
  SIDEBAR_CAMPAIGN_INFO__SET: 'SIDEBAR_CAMPAIGN_INFO__SET',
  TOGGLE_BUDGET_PACING: 'TOGGLE_BUDGET_PACING',
  RESET_ADVANCE_STORE: 'RESET_ADVANCE_STORE',
  SET_STATES: 'SET_STATES',
};
